import { Award, Gift } from "lucide-react";
import { Card, CardContent } from "../../components/ui/card";
import { WiredMeuNivel, WiredNivelResgate } from "../../services/wired";

function descreverRecompensa(r: WiredMeuNivel["recompensas"][number]): string {
  const frequencia = r.a_cada === 1 ? "A cada nível" : `A cada ${r.a_cada} níveis`;
  const inicio = r.a_partir_de > 2 ? ` (a partir do nível ${r.a_partir_de})` : "";
  return `${frequencia}${inicio}: +${r.valor} ${r.rotulo}`;
}

export function NiveisCard({ niveis, resgates }: { niveis: WiredMeuNivel[]; resgates: WiredNivelResgate[] }) {
  if (niveis.length === 0 && resgates.length === 0) return null;

  return (
    <div className="space-y-3">
      {resgates.map((r, i) => (
        <div
          key={`${r.nome}-${r.ate_nivel}-${i}`}
          className="flex items-start gap-2 rounded-md border border-amber-400/50 bg-amber-400/10 px-3 py-2 text-sm"
        >
          <Gift className="mt-0.5 h-4 w-4 shrink-0 text-amber-500" />
          <div>
            <p className="font-semibold text-foreground">
              {r.nome}: nível {r.de_nivel} → {r.ate_nivel}
            </p>
            <p className="text-muted-foreground">
              Recompensa recebida: {r.ganhos.map((g) => `+${g.quantidade} ${g.rotulo}`).join(", ")}
            </p>
          </div>
        </div>
      ))}

      {niveis.map((n) => (
        <Card key={n.id}>
          <CardContent className="space-y-2 py-4">
            <div className="flex items-center justify-between gap-2">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
                <Award className="h-4 w-4" />
                {n.nome}
              </h3>
              <span className="text-lg font-bold text-foreground">
                Nível {n.nivel}
                <span className="text-xs font-normal text-muted-foreground"> / {n.nivel_maximo}</span>
              </span>
            </div>

            <div
              className="h-3 overflow-hidden rounded-full bg-muted"
              role="progressbar"
              aria-valuemin={0}
              aria-valuemax={100}
              aria-valuenow={n.percentual}
            >
              <div className="h-full rounded-full bg-amber-400 transition-all" style={{ width: `${n.percentual}%` }} />
            </div>

            <p className="text-xs text-muted-foreground">
              {n.no_maximo
                ? `Nível máximo alcançado · ${n.xp.toLocaleString("pt-BR")} XP`
                : `${n.progresso.toLocaleString("pt-BR")} / ${n.xp_necessario.toLocaleString("pt-BR")} XP · faltam ${n.xp_restante.toLocaleString("pt-BR")} para o nível ${n.nivel + 1}`}
            </p>

            {n.recompensas.length > 0 && (
              <ul className="space-y-0.5 text-xs text-muted-foreground">
                {n.recompensas.map((r) => (
                  <li key={`${r.rotulo}-${r.a_cada}-${r.a_partir_de}`}>🎁 {descreverRecompensa(r)}</li>
                ))}
              </ul>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
